// extracted by mini-css-extract-plugin
export default {"item":"KH2T2GC2"};